import { render, staticRenderFns } from "./valida-certificado.vue?vue&type=template&id=0f447430&"
import script from "./valida-certificado.vue?vue&type=script&lang=js&"
export * from "./valida-certificado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports